/*! React Starter Kit | MIT License | http://www.reactstarterkit.com/ */

import { canUseDOM } from 'fbjs/lib/ExecutionEnvironment';
import createHistory from 'history/createBrowserHistory';

const location = canUseDOM ? createHistory(): {};

export default location;
